export default function(ctx, inject) {
  inject('tenant', {
    get active() {
      return 'paouris-tractors'
    }
  })
}
